<label *ngIf="!graphicMode" class="switch">
  <input type="checkbox" [disabled]="disabled" [ngModel]="status" (ngModelChange)="toggle($event)">
  <span class="slider round"></span>
  <span class="slider_icon"></span>
</label>

<label *ngIf="graphicMode" class="body all-elements" [ngClass]="status?'colors-active': 'colors-notActive'" (click)="toggle($event)">
  <label class="all-elements circle" (click)="toggle($event)"
         [ngClass]="status?'colors-active position-active':'colors-notActive position-notActive'">
    <i class="icon" [ngClass]="status?'icon__check':'icon__minus'"></i>
  </label>
</label>
